import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators';

import { Store } from '@ngrx/store';
import { AppState } from '../../../app.state';

import { Appointment } from '../../../shared/models/appointment.model';
import { Group } from '../../../shared/models/group.model';
import { Patient } from '../../../shared/models/patient.model';
import { Reason } from '../../../shared/models/reason.model';

import { authenticatedPatientSelector } from '../../../../main/selectors/patients-selectors';
import { getAppointments } from '../appointments.reducer';
import { getSelectedPatients } from '../../reasons/reasons.reducer';
import { ResetSelectedPatients } from '../../reasons/reasons.actions';
import { ResetAppointments } from '../appointments.actions';
import { ShowFlash, DismissFlash } from '../../../shared/flash/store/flash.actions';
import { AppointmentMock } from '../appointment.mock';

import * as moment from 'moment';
import { kebabCase, orderBy } from 'lodash';

@Component({
  selector: 'appointments-confirmation',
  template: require('./appointments-confirmation.component.html'),
  styles: [require('./appointments-confirmation.component.scss')],
})
export class AppointmentsConfirmationComponent implements OnInit, OnDestroy {
  private destroy$: Subject<boolean> = new Subject();

  appointments: any = [];

  currentReason$: Observable<Reason>;
  group$: Observable<Group>;
  authenticatedPatient$: Observable<Patient>;
  selectedPatients: any;

  constructor(
    private store: Store<AppState>,
    @Inject('LoadingService') private loadingService,
  ) {}

  ngOnInit(): void {
    this.loadingService.hide();

    this.group$ = this.store.select((state: AppState) => state.group);
    this.authenticatedPatient$ = this.store.select((state: AppState) => authenticatedPatientSelector(state));
    this.currentReason$ = this.store.select((state: AppState): Reason => state.reasons.current);

    this.store.select(getSelectedPatients)
      .pipe(takeUntil(this.destroy$))
      .subscribe((selectedPatients): void => {
        this.selectedPatients = selectedPatients;
      })

    this.store.select(getAppointments)
      .pipe(takeUntil(this.destroy$))
      .subscribe((appointments): void => {
        this.appointments = appointments;
      })

    this.store.dispatch(new ShowFlash({ name: 'update-profile' }));
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.store.dispatch(new DismissFlash());
    this.store.dispatch(new ResetSelectedPatients());
    this.store.dispatch(new ResetAppointments());
  }

  getAppointmentPatient(appointment): any {
    return this.selectedPatients.find((patient: any): boolean => patient.id === appointment.availability.patientId);
  }

  get formattedReasonCode(): string {
    return this.appointments.length ? kebabCase(this.availability.reason.offering.code) : '';
  }

  get availability(): any {
    return this.appointments.length ? this.appointments[0].availability : {};
  }

  get reason(): any {
    return this.availability.reason || {};
  }

  get account(): any {
    return this.appointments.length ? this.appointments[0].account : {};
  }

  get appointmentsByTime(): any {
    return orderBy(this.appointments, [(appointment: any) => moment(appointment.availability.startTime)]);
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/main/appointments/appointments-confirmation/appointments-confirmation.component.ts